import { Modal } from '@/components/Modal';
import type { ContentfulEventFragment } from '@/graphql/contentful/api';

import { CampaignSubscriptionForm } from '../CampaignSubscriptionForm/CampaignSubscriptionForm';

import * as S from './CampaignSubscriptionModal.styles';

export interface CampaignSubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  urlTrigger?: ContentfulEventFragment;
}

export const CampaignSubscriptionModal = ({
  isOpen,
  onClose,
  urlTrigger,
}: CampaignSubscriptionModalProps) => {
  return (
    <Modal
      data-testid='CampaignSubscriptionModal'
      gutters={false}
      isOpen={isOpen}
      maxWidth='sm'
      onClose={onClose}
    >
      <Modal.Header divider={true} onClose={onClose}>
        <S.Title>{urlTrigger?.title ?? ''}</S.Title>
      </Modal.Header>
      <Modal.Body>
        <S.Body>
          {urlTrigger && (
            <CampaignSubscriptionForm
              {...urlTrigger}
            ></CampaignSubscriptionForm>
          )}
        </S.Body>
      </Modal.Body>
    </Modal>
  );
};

CampaignSubscriptionModal.displayName = 'CampaignSubscriptionModal';
